import axios from "axios";
import { adminServerInstance } from "../axios/instances";
import { getUserPreference } from "../utilities/common";
import { ORDER_EXCHANGE as type } from "./orderExchangeTypes";

/**
 * @param {Object} params
 * @param {number} params.warehouse
 * @param {string} params.tno
 */
export function createAutoTask(params) {
    return function (dispatch) {
        dispatch({ type: type.CREATE_AUTO_TASK })
        return adminServerInstance.post(`/business/createautotask`, params)
            .then(({ data }) => {
                dispatch({
                    type: type.CREATE_AUTO_TASK_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: type.CREATE_AUTO_TASK_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

//
export function getDetailedOrderExchangeInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.SEARCH_DETAILED_INFO})
        return adminServerInstance.post(`/orderexchange/getdetailedinfo`, params)
        .then(({data}) => {
            dispatch({
                type: type.SEARCH_DETAILED_INFO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.SEARCH_DETAILED_INFOL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getSummaryOrderExchangeInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.SEARCH_SUMMARY_INFO})
        return adminServerInstance.post(`/orderexchange/getexecutionsummary`, params)
        .then(({data}) => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFOL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getHourlyOrderExchangeInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.SEARCH_SUMMARY_INFO})
        return adminServerInstance.post(`/orderexchange/getordersperhourcount`, params)
        .then(({data}) => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFOL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getUserOrderExchangeInfo(params) {   
    return function(dispatch) {
        dispatch({type: type.SEARCH_SUMMARY_INFO})
        return adminServerInstance.post(`/orderexchange/getconfirmedreport`, params)
        .then(({data}) => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFOL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.SEARCH_SUMMARY_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function downloadDetailedOrderExchangeInfo(params) {  
    return function(dispatch) {
        dispatch({type: type.DOWNLOAD_DETAILED_INFO})
        return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/orderexchange/downloaddetailedinfo`, params,{
            responseType: 'blob',
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: type.DOWNLOAD_DETAILED_INFOL_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json"){
                return Promise.resolve(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `detailed_order_exchange.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: type.DOWNLOAD_DETAILED_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function downloadSummarydOrderExchangeInfo(params) {  
    return function(dispatch) {
        dispatch({type: type.DOWNLOAD_SUMMARY_INFO})
        return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/orderexchange/downloadexecutionsummarysheet`, params,{
            responseType: 'blob',
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: type.DOWNLOAD_SUMMARY_INFO_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json"){
                return Promise.resolve(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `summary_order_exchange.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: type.DOWNLOAD_SUMMARY_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function downloadTimmingOrderExchangeInfo(params) {  
    return function(dispatch) {
        dispatch({type: type.DOWNLOAD_TIMING_INFO})
        return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/orderexchange/downloadordersperhourcount`, params,{
            responseType: 'blob',
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: type.DOWNLOAD_TIMING_INFO_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json"){
                return Promise.resolve(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `timming_order_exchange.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: type.DOWNLOAD_TIMING_INFO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function downloadUserOrderExchangeInfo(params) {  
    return function(dispatch) {
        dispatch({type: type.DOWNLOAD_USER_INFO})
        return axios.post(`${process.env.REACT_APP_MAP_SERVER_URL}/orderexchange/downloadconfirmedreport`, params,{
            responseType: 'blob',
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: type.DOWNLOAD_USER_INFO_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json"){
                return Promise.resolve(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `user_order_exchange.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: type.DOWNLOAD_USER_INFOL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}
/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.tracking_number
 */
export function printOrderLabel(params) {  
    return function(dispatch) {
        dispatch({type: type.PRINT_ORDER_LABEL})
        return axios.get(`${process.env.REACT_APP_MAP_SERVER_URL}/business/printorderlabel`, {
            params,
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${getUserPreference().authToken}`
            },
            timeout: 0
        })
        .then((response) => {
            dispatch({
                type: type.PRINT_ORDER_LABEL_SUCCESS,
                payload: response
            })
            if (response.headers['content-type'] === "application/json") {
                return Promise.reject(response);
            } else {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${params.tracking_number}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                return Promise.resolve(response);
            }
        })
        .catch((error) => {
            dispatch({
                type: type.PRINT_ORDER_LABEL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.task_id
 */
export function queryTaskDetail(params) {   
    return function(dispatch) {
        dispatch({type: type.QUERY_TASK_DETAIL})
        return adminServerInstance.get(`/business/querytaskdetail`, {params: params})
        .then(({data}) => {
            dispatch({
                type: type.QUERY_TASK_DETAIL_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.QUERY_TASK_DETAIL_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.task_id
 */
export function completeTask(params) {   
    return function(dispatch) {
        dispatch({type: type.COMPLETE_TASK})
        return adminServerInstance.post(`/business/completetask`, params)
        .then(({data}) => {
            dispatch({
                type: type.COMPLETE_TASK_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.COMPLETE_TASK_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.start_time
 * @param {string} params.end_time
 * @param {string} params.warehouse
 * @param {Number} params.task_status 0: TASK_ORDER_STATUS_NEW; 1: TASK_ORDER_STATUS_CREATED; 2: TASK_ORDER_STATUS_LABELED; 3: TASK_ORDER_STATUS_FAILED
 * @param {string} params.creator
 */
export function queryTaskList(params) {   
    return function(dispatch) {
        dispatch({type: type.QUERY_TASK_LIST})
        return adminServerInstance.get(`/business/querytasklist`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: type.QUERY_TASK_LIST_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.QUERY_TASK_LIST_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {Array} params.orders
 * @param {Number} params.warehouse
 */
export function createTask(params) {   
    return function(dispatch) {
        dispatch({type: type.CREATE_TASK})
        return adminServerInstance.post(`/business/createtask`, params)
        .then(({data}) => {
            dispatch({
                type: type.CREATE_TASK_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.CREATE_TASK_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.task_id
 * @param {string} params.tno
 * @param {string} params.carrier_code
 */
export function forwardOrder(params) {   
    return function(dispatch) {
        dispatch({type: type.FORWARD_ORDER})
        return adminServerInstance.post(`/business/forwardorder`, params)
        .then(({data}) => {
            dispatch({
                type: type.FORWARD_ORDER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.FORWARD_ORDER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.start_time
 * @param {string} params.end_time
 * @param {string} params.warehouse
 * @param {string} params.transship_status 0: TASK_STATUS_NEW; 1: TASK_STATUS_PROCESSING; 2: TASK_STATUS_DONE
 * @param {string} params.tnos[]
 */
export function queryToBeForwardOrders(params) {   
    return function(dispatch) {
        dispatch({type: type.QUERY_TO_BE_FORWARD_ORDERS})
        return adminServerInstance.get(`/business/querytobeforwardorders`, {
            params: params
        }, { timeout: 0 })
        .then(({data}) => {
            dispatch({
                type: type.QUERY_TO_BE_FORWARD_ORDERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: type.QUERY_TO_BE_FORWARD_ORDERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}